/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Button } from "react-bootstrap";

const CustomButton = ({
  variant,
  type,
  className,
  children,
  onClick,
  isDisabled,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // Determine dynamic styles
  const dynamicStyles = () => {
    switch (variant) {
      case "primary":
        return {
          backgroundColor: isHovered ? "#013b66" : "#005A9C",
          color: "white",
        };
      case "danger":
        return {
          backgroundColor: isHovered ? "#7e1010" : "#a02323",
          color: "white",
        };
      default:
        return {};
    }
  };

  return (
    <Button
      variant={variant}
      type={type}
      className={className}
      disabled={isDisabled}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        fontFamily: "Arial, sans-serif",
        borderRadius: "0px",
        border: "0px",
        display: 'flex',
        flexDirection:"row",
        alignItems:"center",
        justifyContent:"center",
        ...dynamicStyles(), // Apply dynamic styles
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
